import React from 'react'
import { useSelector } from 'react-redux';

export default function modifyremark(remarks,mobileno)
{ // if(remarks== "COD Amount not ready with the Customer"){
    //     return ['We were unable to deliver...', true]

    if(remarks== "Customer not answering calls" || remarks == "Phone number is wrong" || remarks == "Phone is switched off / not reachable" )
    {
        return ["Order Failed to Deliver",`We tried delivering your order but were unable to connect with you on    ${"   "}${" "}<strong>${mobileno}</strong> . If you want to request a reattempt or report a wrong status update please click 'Edit'. `, false, "Edit","226px","143px"]
    }

    else if(remarks== "Customer refused to accept")
    {
       return ["Order Failed to Deliver","Our delivery partner has updated buyer requested cancellation for this order. If you still want the order or want to report a wrong status update please click 'Edit'" , true, "Edit","209px","150px"]
    }

    else if(remarks == "Customer wants to reschedule for a future date" || remarks == "Customer wants to reschedule for tomorrow" || remarks == "Customer wants to reschedule for day after tomorrow")
    {
       return ["Order Failed to Deliver","We were unable to deliver your order as you have requested for reschedule." , false , "Edit","160px","125px"]
    }

    else if(remarks == "Rescheduled for tomorrow due to Operational Constraint" || remarks == "Rescheduled due to operational constraint")
    {
        return ["Order Failed to Deliver", "We were unable to deliver your order due to operational constraints. We have arranged for a re-attempt, you will receive your order shortly" , false , "Edit","200px","140px"]
    }

    else if(remarks == "Wrong Address / Incomplete Address")
    {
        return ["Order Failed to Deliver","We were unable to deliver your order since the address provided was incorrect. Click on “Edit” to update your delivery address.", false , "Edit","187px","140px"]
    }

    else if (remarks == "")
    {
      return ["Order Failed to Deliver","As per information received, you requested a cancellation. To cancel your order or request a re-attempt, please proceed below.", false , "Edit","200px","140px"]

    }

    else
    {
       return ["Order Failed to Deliver","We tried delivering your order but were not able to complete the attempt successfully. Please select a date for re-attempt or report delivery partner misbehaviour by clicking on 'Edit'.", false , "Edit","230px","145px"]
    }
}



